// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"cf100ad0","453":"d24111bf","455":"c717be89","977":"1005ee8c"}[chunkId] + ".chunk.js";
};